import type { RotasDoModulo } from '@/app/rotas';

import { LogsPage } from './LogsPage';

/** Logs da seguradora: auditoria, acessos e tarefas (P-LOG). */
export const rotas: RotasDoModulo = {
  menu: { '/logs': LogsPage },
};
